module.exports = __webpack_public_path__ + "static/02-illustration-fdc272c73ffcc5a04e02992ebf5f957a.svg";